module.exports = __webpack_public_path__ + "img/GAME_OXQUIZ.ac8975e1.jpg";